export default __webpack_public_path__ + "static/media/language-cs.b4148791.svg";